import { render, staticRenderFns } from "./FilterMatching.vue?vue&type=template&id=bbef4ef0&scoped=true&"
import script from "./FilterMatching.vue?vue&type=script&lang=js&"
export * from "./FilterMatching.vue?vue&type=script&lang=js&"
import style0 from "./FilterMatching.vue?vue&type=style&index=0&id=bbef4ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbef4ef0",
  null
  
)

export default component.exports